import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import qs from 'qs';
import { CreateEventPropositionRequest, EventsAvailabilitiesRequest } from '../types';

const eventPropositionsApiUrl = '/EventPropositions';
export const eventsApiUrl = '/Events';
export const eventsLocationsApiUrl = `${eventsApiUrl}/locations`;
const eventsAvailabilitiesApiUrl = `${eventsApiUrl}/availabilities`;

const ApiUrls = {
  eventsApiUrl,
  eventPropositionsApiUrl,
  eventsAvailabilitiesApiUrl
};

const PostEventPropositionRequest = (data: CreateEventPropositionRequest) =>
  nzApiAxios.post(eventPropositionsApiUrl, data);

const GetEventsRequest = (page = 1, query = {}) =>
  nzApiAxios
    .get(eventsApiUrl, {
      params: { ...query, page },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((response) => response.data);

const GetEventRequest = (slug: string | undefined) =>
  nzApiAxios.get(`${eventsApiUrl}/${slug}`).then((response) => response.data);

const GetEventsAvailabilitiesRequest = (data: EventsAvailabilitiesRequest) =>
  nzApiAxios.get(eventsAvailabilitiesApiUrl, { params: data }).then((response) => response.data);

const GetEventsLocations = () => nzApiAxios.get(eventsLocationsApiUrl).then((response) => response.data);

const API = {
  proposeEvent: PostEventPropositionRequest,
  getEvents: GetEventsRequest,
  getEvent: GetEventRequest,
  getEventsAvailabilities: GetEventsAvailabilitiesRequest,
  getEventsLocations: GetEventsLocations
};

export { ApiUrls };
export default API;
